import { render, staticRenderFns } from "./ConfirmSavePopup.vue?vue&type=template&id=522a9172"
import script from "./ConfirmSavePopup.vue?vue&type=script&lang=js"
export * from "./ConfirmSavePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports